var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "productDetail-container" },
    [
      _c("div", { staticStyle: { background: "#fff" } }, [
        _c("div", [
          _c("div", { staticClass: "shop" }, [
            _c("div", { staticClass: "toutou" }, [
              _c(
                "div",
                {
                  staticClass: "warp",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "left",
                    padding: "20px 0",
                    "margin-top": "20px"
                  }
                },
                [
                  _c("div", [
                    _c("img", {
                      staticClass: "logo",
                      attrs: {
                        src: require("../../assets/images/dlogo.png"),
                        alt: ""
                      },
                      on: { click: _vm.gotoIndex }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: {
                      width: "2px",
                      height: "40px",
                      "background-color": "#eeeff1",
                      margin: "10px 20px"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "menu",
                      on: {
                        mouseover: function($event) {
                          _vm.$route.name !== "index"
                            ? (_vm.showClassify2 = true)
                            : null
                        },
                        mouseout: function($event) {
                          _vm.showClassify2 = false
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "menu-flag" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "el-icon-arrow-right",
                          class:
                            "" + (_vm.showClassify2 ? "turnDown" : "turnDown2"),
                          staticStyle: {
                            "margin-left": "4px",
                            "margin-top": "2px"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showClassify2,
                                expression: "showClassify2"
                              }
                            ],
                            staticClass: "classify-outer",
                            staticStyle: {
                              "background-color": "#fff",
                              "z-index": "999",
                              "margin-top": "-12px"
                            },
                            on: {
                              mouseout: function($event) {
                                _vm.showClassify2 = true
                              }
                            }
                          },
                          [
                            _c("cere-classification", {
                              staticStyle: { height: "auto !important" },
                              attrs: {
                                componentContent:
                                  _vm.componentContent[0].componentContent
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "searchright" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "right",
                          height: "60px !important"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "shuru",
                          attrs: {
                            size: "large",
                            placeholder: "请输入内容",
                            "prefix-icon": "el-icon-search"
                          },
                          model: {
                            value: _vm.searchFrom.search,
                            callback: function($$v) {
                              _vm.$set(_vm.searchFrom, "search", $$v)
                            },
                            expression: "searchFrom.search"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "quanzhan" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "qzBtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.getAllProduct }
                              },
                              [_vm._v("搜全站")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "bendain" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "bdBtn",
                            attrs: { type: "info" },
                            on: { click: _vm.getInfoProduct }
                          },
                          [_vm._v("搜本店")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "shopHeaderBj" }, [
              _c("div", { staticClass: "shop1" }, [
                _c(
                  "div",
                  {
                    staticClass: "warp",
                    staticStyle: {
                      padding: "20px 0 0 20px",
                      position: "relative"
                    }
                  },
                  [
                    _c("div", { staticClass: "shopInfo-box" }, [
                      _c("div", { staticClass: "shopHeard" }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "left"
                            }
                          },
                          [
                            _c("div", [
                              _c(
                                "h2",
                                {
                                  staticClass: "shopName",
                                  on: {
                                    click: function($event) {
                                      return _vm.goStore()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.curShop.shopName) +
                                      "\n                      "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "guanzhu",
                                style:
                                  _vm.isCare == 0
                                    ? ""
                                    : "background-color: rgba(255, 71, 71, 1);color: #fff;",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.collectShop.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(
                                      _vm.isCare == 0 ? "关注" : "已关注"
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "shopCode",
                                staticStyle: {
                                  "margin-left": "20px",
                                  cursor: "pointer",
                                  position: "relative"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "30px",
                                    "margin-top": "8px"
                                  },
                                  attrs: {
                                    src: require("@/assets/images/shopCode.png"),
                                    alt: ""
                                  },
                                  on: {
                                    mouseout: function($event) {
                                      _vm.shopCode = false
                                    },
                                    mouseover: function($event) {
                                      _vm.shopCode = true
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.shopCode == true
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          position: "absolute",
                                          top: "0px",
                                          left: "50px",
                                          "z-index": "1000",
                                          background: "#ffffff",
                                          width: "250px",
                                          height: "250px",
                                          "text-align": "center",
                                          padding: "10px",
                                          "box-shadow": "0px 5px 10px 0px",
                                          "border-radius": "4px"
                                        }
                                      },
                                      [
                                        _c("vue-qr", {
                                          attrs: {
                                            size: 200,
                                            margin: 0,
                                            "auto-color": true,
                                            "dot-scale": 1,
                                            text: _vm.appSrc
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              "text-align": "center",
                                              "margin-top": "5px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          店铺二维码（手机APP扫码）\n                        "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "information" }, [
                          _c("img", {
                            staticClass: "renzheng",
                            attrs: {
                              src: require("../../assets/images/renzheng.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "dizhi" }, [
                            _c("i", {
                              staticClass: "icon-positioning",
                              staticStyle: {
                                color: "#fb7600",
                                "font-size": "20px",
                                "margin-right": "5px"
                              }
                            }),
                            _vm._v(
                              "\n                      " +
                                _vm._s(this.adressForm.shopAdress)
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "550px",
                            "font-size": "24px",
                            "font-weight": "bold",
                            color: "#864c17",
                            position: "absolute",
                            top: "50px",
                            left: "45%"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  严选优质商品  直供源价好货\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "15px" } }, [
                        _c("div", { staticClass: "block11" }, [
                          _c("img", {
                            staticClass: "img1",
                            attrs: {
                              referrerpolicy: "no-referrer",
                              src: require("../../assets/images/tel.png")
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "5px",
                                "margin-left": "10px"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "info34",
                                  staticStyle: {
                                    "font-size": "16px",
                                    color: "#333"
                                  }
                                },
                                [_vm._v("店铺服务热线:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "18px",
                                    color: "#333"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.formData.chargePersonPhone))]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "el-tab-box" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs warp",
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c("el-tab-pane", { attrs: { label: "首页", name: "index" } }),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  staticStyle: { position: "relative" },
                  attrs: { label: "产品分类", name: "shopClassifyList" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "inline-block", height: "100%" },
                      attrs: { slot: "label" },
                      on: {
                        mouseover: function($event) {
                          _vm.showMenu = true
                        },
                        mouseleave: function($event) {
                          _vm.showMenu = false
                        }
                      },
                      slot: "label"
                    },
                    [
                      _vm._v("\n          产品分类\n          "),
                      _c("i", {
                        class: _vm.showMenu
                          ? "el-icon-caret-bottom selectMenu"
                          : "el-icon-caret-bottom"
                      }),
                      _vm._v(" "),
                      _vm.showMenu
                        ? _c(
                            "div",
                            {
                              staticClass: "ShopMenu",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _c("div", { staticClass: "menuall" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "border-right": "1px solid #e5e5e5"
                                    }
                                  },
                                  _vm._l(_vm.categoryItem, function(
                                    item,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "menuItem",
                                        on: {
                                          mouseover: function($event) {
                                            return _vm.getChildren(item)
                                          },
                                          mouseleave: _vm.clianChildren,
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.handleClickMenu(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(item.classifyName))
                                        ]),
                                        _vm._v(" "),
                                        _c("i", {
                                          class: _vm.showMenu2
                                            ? "el-icon-arrow-right selectMenu2"
                                            : "el-icon-arrow-right",
                                          staticStyle: { "margin-left": "10px" }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "background-color": "#fff",
                                      color: "#000"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "hoverBox" },
                                      _vm._l(_vm.menuChildren.childs, function(
                                        subItem,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index, staticClass: "dl" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "dt",
                                                staticStyle: {
                                                  cursor: "pointer"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.goStoreClassifyDetail(
                                                          subItem.classifyId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        subItem.classifyName
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "dd" },
                                              _vm._l(subItem.childs, function(
                                                threeItem,
                                                index
                                              ) {
                                                return _c(
                                                  "a",
                                                  {
                                                    key: index,
                                                    staticClass: "a-link"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.goStoreClassifyDetail(
                                                              threeItem.classifyId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            threeItem.classifyName
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: { label: "公司档案", name: "dossier" }
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: { label: "联系我们", name: "contact" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "productBox warp" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.detailLoading,
                expression: "detailLoading"
              }
            ],
            staticClass: "productConcise clearfix"
          },
          [
            _c(
              "div",
              { staticClass: "swiper-box" },
              [
                _c(
                  "swiper",
                  {
                    ref: "swiperTop",
                    staticClass: "gallery-top",
                    staticStyle: { border: "1px solid #e4e4e4" },
                    attrs: { options: _vm.swiperOptionTop }
                  },
                  _vm._l(_vm.productDetailData.images, function(item) {
                    return _c(
                      "swiper-slide",
                      { key: item, staticStyle: { "text-align": "center" } },
                      [
                        _c("img", {
                          staticStyle: { height: "100%", width: "auto" },
                          attrs: { src: item, alt: "" }
                        })
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "swiperThumbsLeft" }, [
                  _c(
                    "div",
                    { staticClass: "thumbsBox" },
                    [
                      _c(
                        "swiper",
                        {
                          ref: "swiperThumbs",
                          staticClass: "gallery-thumbs",
                          attrs: { options: _vm.swiperOptionThumbs }
                        },
                        _vm._l(_vm.productDetailData.images, function(
                          item,
                          index
                        ) {
                          return _c(
                            "swiper-slide",
                            { key: index, attrs: { img: item } },
                            [
                              _c("img", {
                                attrs: { src: item, alt: "", srcset: "" }
                              })
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "image-button-prev",
                          attrs: { slot: "button-prev" },
                          slot: "button-prev"
                        },
                        [_c("a-icon", { attrs: { type: "left" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "image-button-next",
                          attrs: { slot: "button-next" },
                          slot: "button-next"
                        },
                        [_c("a-icon", { attrs: { type: "right" } })],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "left",
                      width: "440px",
                      "padding-left": "10px",
                      "margin-bottom": "-30px",
                      "margin-top": "50px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "favoritesBtn",
                        attrs: { title: "收藏" },
                        on: { click: _vm.collect }
                      },
                      [
                        _c("span", {
                          class:
                            "" +
                            (_vm.productDetailData.ifCollect === 0
                              ? "icon-shoucang"
                              : "icon-shoucang1")
                        }),
                        _vm._v(" "),
                        _vm.productDetailData.ifCollect === 0
                          ? _c(
                              "span",
                              { staticStyle: { color: "#000000a6" } },
                              [_vm._v("收藏")]
                            )
                          : _c(
                              "span",
                              { staticStyle: { color: "#000000a6" } },
                              [_vm._v("已收藏")]
                            )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("a-spin", { attrs: { spinning: _vm.spinning } }, [
              _c("div", { staticClass: "proDuctInfo" }, [
                _c("h3", { staticClass: "productTit" }, [
                  _vm._v(_vm._s(_vm.productDetailData.productName))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "introduction" }, [
                  _vm._v(_vm._s(_vm.productDetailData.productBrief))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "priceDataInfo" }, [
                  _vm.currentProductData.activityType === 1 && false
                    ? _c("div", [
                        _c("div", { staticClass: "groupBuyInfo" }, [
                          _c("div", { staticClass: "groupLeft" }, [
                            _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("拼团专区")])
                          ]),
                          _vm._v(" "),
                          _vm.ifEnable === 0
                            ? _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.productDetailData.person) +
                                    "人团\n                "
                                )
                              ])
                            : _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.productOption.skuTool.startTime
                                    ) +
                                    " 活动开启\n                "
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "priceSpike mar-bot-20" }, [
                          _c("div", { staticClass: "priceSpikeLeft" }, [
                            _vm._v(
                              "\n                  拼团价：\n                  "
                            ),
                            _c("b", [
                              _vm._v(
                                "￥" + _vm._s(_vm.currentProductData.price)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(_vm.currentProductData.originalPrice)
                              )
                            ])
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.activityType === 2 && false
                    ? _c("div", [
                        _c("div", { staticClass: "groupBuyInfo" }, [
                          _c("div", { staticClass: "groupLeft" }, [
                            _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("秒杀专区")])
                          ]),
                          _vm._v(" "),
                          _vm.ifEnable === 0
                            ? _c("div", { staticClass: "countdown" }, [
                                _c("div", { staticClass: "countdownTit" }, [
                                  _vm._v("距离结束:")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "timeDown" }, [
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("formatHours")(_vm.endTime))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMinutes")(_vm.endTime)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatSeconds")(_vm.endTime)
                                      )
                                    )
                                  ])
                                ])
                              ])
                            : _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.productOption.skuTool.startTime
                                    ) +
                                    " 活动开启\n                "
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "priceSpike mar-bot-20" }, [
                          _c("div", { staticClass: "priceSpikeLeft" }, [
                            _vm._v(
                              "\n                  秒杀价：\n                  "
                            ),
                            _c("b", [
                              _vm._v(
                                "￥" + _vm._s(_vm.currentProductData.price)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(_vm.currentProductData.originalPrice)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.productDetailData.total && _vm.ifEnable === 0
                            ? _c(
                                "div",
                                { staticClass: "priceSpikeRight" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                    限量" +
                                        _vm._s(_vm.productDetailData.total) +
                                        "件/还剩" +
                                        _vm._s(
                                          _vm.productDetailData.surplusNumber
                                        ) +
                                        "件\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-progress", {
                                    attrs: {
                                      "text-inside": true,
                                      "stroke-width": 10,
                                      percentage:
                                        ((_vm.productDetailData.total -
                                          _vm.productDetailData.surplusNumber) /
                                          _vm.productDetailData.total) *
                                        100,
                                      status: "exception"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.activityType === 3 && false
                    ? _c("div", [
                        _c("div", { staticClass: "groupBuyInfo" }, [
                          _c("div", { staticClass: "groupLeft" }, [
                            _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("限时折扣")])
                          ]),
                          _vm._v(" "),
                          _vm.ifEnable === 0
                            ? _c("div", { staticClass: "countdown" }, [
                                _c("div", { staticClass: "countdownTit" }, [
                                  _vm._v("距离结束:")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "timeDown" }, [
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("formatHours")(_vm.endTime))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatMinutes")(_vm.endTime)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(":")]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatSeconds")(_vm.endTime)
                                      )
                                    )
                                  ])
                                ])
                              ])
                            : _c("div", { staticClass: "groupRight" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.productOption.skuTool.startTime
                                    ) +
                                    " 活动开启\n                "
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "priceSpike mar-bot-20" }, [
                          _c("div", { staticClass: "priceSpikeLeft" }, [
                            _vm._v(
                              "\n                  折扣价：\n                  "
                            ),
                            _c("b", [
                              _vm._v(
                                "￥" + _vm._s(_vm.currentProductData.price)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(_vm.currentProductData.originalPrice)
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.productDetailData.total && _vm.ifEnable === 0
                            ? _c(
                                "div",
                                { staticClass: "priceSpikeRight" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "\n                    限量" +
                                        _vm._s(_vm.productDetailData.total) +
                                        "件/还剩" +
                                        _vm._s(
                                          _vm.productDetailData.surplusNumber
                                        ) +
                                        "件\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("el-progress", {
                                    attrs: {
                                      "text-inside": true,
                                      "stroke-width": 10,
                                      percentage:
                                        ((_vm.productDetailData.total -
                                          _vm.productDetailData.surplusNumber) /
                                          _vm.productDetailData.total) *
                                        100,
                                      status: "exception"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "promotionInfo",
                      staticStyle: {
                        display: "flex",
                        "align-items": "baseline"
                      }
                    },
                    [
                      _c("span", [_vm._v("价格:")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "baseline"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "baseline"
                              }
                            },
                            [
                              _c(
                                "small",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "end"
                                  }
                                },
                                [_vm._v("¥")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    margin: "0 6px",
                                    display: "flex",
                                    "align-items": "end"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.currentProductData.price) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.productDetailData.timeSkuStatus
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "16px",
                                        display: "flex",
                                        "align-items": "end"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          "/ " +
                                            _vm.productDetailData.timeSkuName
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          false
                            ? _c("span", [
                                _c("small", [_vm._v("¥")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "-2px" } },
                                  [_vm._v(_vm._s(_vm.currentProductPrice.min))]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentProductPrice.min !==
                            _vm.currentProductPrice.max && false
                            ? [
                                _c("span", [_vm._v("-")]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("small", [_vm._v("¥")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "-2px" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.currentProductPrice.max)
                                      )
                                    ]
                                  )
                                ])
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "proDiscount" },
                    [
                      _vm._l(_vm.productDetailData.markTools, function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index, staticClass: "activityLabel" },
                          [
                            _c("span", [_vm._v(_vm._s(item.activityName))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("优惠券：" + _vm._s(item.content))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.getThisCoupon(item, index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(item.state === 3 ? "领取" : "已领取")
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.productDetailData.shopMarkTools, function(
                        item,
                        index
                      ) {
                        return _c(
                          "div",
                          { key: index, staticClass: "activityLabel" },
                          [
                            _c("span", [_vm._v(_vm._s(item.activityName))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("优惠券：" + _vm._s(item.content))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.getThisCoupon1(item, index)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(item.state === 3 ? "领取" : "已领取")
                                )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sku-box" },
                  [
                    _vm._l(_vm.productOption.names, function(it) {
                      return _c("ul", { key: it.nameCode }, [
                        _c("li", [
                          _c("p", { staticClass: "proDescribeTit" }, [
                            _vm._v(
                              _vm._s(it.skuName === "" ? "" : it.skuName + ":")
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            _vm._l(it.values, function(kt) {
                              return _c(
                                "span",
                                {
                                  key: kt.valueCode,
                                  class: [{ "selected-item": kt.selected }],
                                  on: {
                                    click: function($event) {
                                      return _vm.selectSku(kt, it)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(kt.skuValue) +
                                      "\n                  "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _vm.productOption.extraSkus
                      ? _vm._l(_vm.productOption.extraSkus.names, function(it) {
                          return _c("ul", { key: it.nameCode }, [
                            _c("li", [
                              _c("p", { staticClass: "proDescribeTit" }, [
                                _vm._v(
                                  _vm._s(
                                    it.skuName === "" ? "" : it.skuName + ":"
                                  ) +
                                    " (价格:\n                    ¥" +
                                    _vm._s(
                                      _vm.curExtraSku
                                        ? _vm.curExtraSku.extraSkuPrice
                                        : 0
                                    ) +
                                    "元)"
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                _vm._l(it.values, function(kt) {
                                  return _c(
                                    "span",
                                    {
                                      key: kt.valueCode,
                                      class: [{ "selected-item": kt.selected }],
                                      on: {
                                        click: function($event) {
                                          return _vm.selectSkuServ(kt, it)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(kt.skuValue) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.productDetailData.timeSkuStatus
                      ? _c("ul", [
                          _c("li", [
                            _c(
                              "p",
                              {
                                staticClass: "proDescribeTit",
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  租赁时间(单位/" +
                                    _vm._s(_vm.productDetailData.timeSkuName) +
                                    "):\n                  " +
                                    _vm._s(
                                      _vm.timeArea ? _vm.formatTimeShow() : ""
                                    ) +
                                    "\n                  "
                                ),
                                _vm.timeDiffInfo
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "10px",
                                          "font-size": "13px",
                                          "font-weight": "bold"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.timeDiffInfo))]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.productDetailData.timeSkuValue == 1
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "selfDateAreaComponent selfDateTimeAreaComponent"
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "datetimerange",
                                        "unlink-panels": true,
                                        "range-separator": "-",
                                        "start-placeholder": "开始时间",
                                        "end-placeholder": "结束时间"
                                      },
                                      model: {
                                        value: _vm.timeArea,
                                        callback: function($$v) {
                                          _vm.timeArea = $$v
                                        },
                                        expression: "timeArea"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.productDetailData.timeSkuValue == 2
                              ? _c(
                                  "p",
                                  { staticClass: "selfDateAreaComponent" },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "daterange",
                                        "unlink-panels": true,
                                        "range-separator": "-",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      on: { change: _vm.dateRangeChange },
                                      model: {
                                        value: _vm.timeArea,
                                        callback: function($$v) {
                                          _vm.timeArea = $$v
                                        },
                                        expression: "timeArea"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.productDetailData.timeSkuValue == 3
                              ? _c(
                                  "p",
                                  { staticClass: "selfDateComponent" },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "date",
                                        placeholder: "开始日期"
                                      },
                                      model: {
                                        value: _vm.timeAreaSingle,
                                        callback: function($$v) {
                                          _vm.timeAreaSingle = $$v
                                        },
                                        expression: "timeAreaSingle"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  共计租赁\n                  "
                                    ),
                                    _c("el-input-number", {
                                      attrs: {
                                        "step-strictly": "",
                                        min: 1,
                                        max: 60,
                                        size: "mini",
                                        placeholder: ""
                                      },
                                      model: {
                                        value: _vm.timeAreaSingleNum,
                                        callback: function($$v) {
                                          _vm.timeAreaSingleNum = $$v
                                        },
                                        expression: "timeAreaSingleNum"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  月\n                "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.productDetailData.timeSkuValue == 4
                              ? _c(
                                  "p",
                                  { staticClass: "selfDateComponent" },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        type: "date",
                                        placeholder: "开始日期"
                                      },
                                      model: {
                                        value: _vm.timeAreaSingle,
                                        callback: function($$v) {
                                          _vm.timeAreaSingle = $$v
                                        },
                                        expression: "timeAreaSingle"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  共计租赁\n                  "
                                    ),
                                    _c("el-input-number", {
                                      attrs: {
                                        "step-strictly": "",
                                        min: 1,
                                        max: 10,
                                        size: "mini",
                                        placeholder: ""
                                      },
                                      model: {
                                        value: _vm.timeAreaSingleNum,
                                        callback: function($$v) {
                                          _vm.timeAreaSingleNum = $$v
                                        },
                                        expression: "timeAreaSingleNum"
                                      }
                                    }),
                                    _vm._v(
                                      "\n                  年\n                "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    false
                      ? _c("div", { staticClass: "table-container" }, [
                          _c("span", [_vm._v("规格")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              class:
                                "" +
                                (_vm.tableData.length > 6 && _vm.isHidden
                                  ? "table-hiddenbox"
                                  : "")
                            },
                            [
                              _c("a-table", {
                                class:
                                  "" +
                                  (_vm.tableData.length > 6 && _vm.isHidden
                                    ? "table-hidden"
                                    : ""),
                                attrs: {
                                  columns: _vm.columns,
                                  "data-source": _vm.tableData,
                                  scroll:
                                    _vm.columns.length > 7 ? { x: 500 } : {},
                                  pagination: false,
                                  size: "small"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "buyNum",
                                      fn: function(item) {
                                        return _c(
                                          "div",
                                          {},
                                          [
                                            item.groupProductStatus == 1
                                              ? _c("el-input-number", {
                                                  attrs: {
                                                    min: 0,
                                                    step: _vm.buyNumMap[
                                                      "" + item.skuId
                                                    ]
                                                      ? 1
                                                      : item.initPurchase,
                                                    value:
                                                      _vm.buyNumMap[
                                                        "" + item.skuId
                                                      ],
                                                    label: "采购数量",
                                                    size: "small",
                                                    type: "number"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.buyNumChange(
                                                        $event,
                                                        item
                                                      )
                                                    }
                                                  }
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#ccc"
                                                    }
                                                  },
                                                  [_vm._v("禁止订货")]
                                                )
                                          ],
                                          1
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1134107836
                                )
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _vm.tableData.length > 6
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "table-hidden-btn",
                                        on: {
                                          click: function($event) {
                                            _vm.isHidden = !_vm.isHidden
                                          }
                                        }
                                      },
                                      [
                                        _c("span", {
                                          class:
                                            "" +
                                            (_vm.isHidden
                                              ? "el-icon-arrow-down"
                                              : "el-icon-arrow-up")
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "total-info" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.totalInfo.totalNum) + " 件"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.totalInfo.totalPrice) + " 元"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("已选清单")])
                                ])
                              ])
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "initBuyNumBox" }, [
                  _c("span", [_vm._v("销量")]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-weight": "normal" } }, [
                    _vm._v(_vm._s(_vm.productDetailData.number))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "initBuyNumBox" }, [
                  _c("span", [_vm._v("说明")]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-weight": "normal" } }, [
                    _vm._v("服务型商品")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "product_buy_num_box",
                    staticStyle: {
                      "margin-top": "15px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("span", { staticStyle: { width: "57px" } }, [
                      _vm._v("数量")
                    ]),
                    _vm._v(" "),
                    _c("el-input-number", {
                      attrs: {
                        "step-strictly": "",
                        min: 1,
                        max: _vm.productDetailData.stockNumber,
                        placeholder: ""
                      },
                      model: {
                        value: _vm.productBuyNum,
                        callback: function($$v) {
                          _vm.productBuyNum = $$v
                        },
                        expression: "productBuyNum"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-left": "10px",
                          "font-size": "12px",
                          "min-width": "100px"
                        }
                      },
                      [
                        _c("div", { staticStyle: { display: "flex" } }, [
                          _vm._v("共" + _vm._s(_vm.productBuyNum) + "件")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "baseline"
                            }
                          },
                          [
                            _c("span", [_vm._v("小计:")]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-weight": "bold",
                                  "margin-left": "4px"
                                }
                              },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      (Number(_vm.getCurSkuPrice()) == 0
                                        ? Number(_vm.getCurSkuPrice())
                                        : Number(_vm.getCurSkuPrice()) +
                                          (_vm.curExtraSku
                                            ? _vm.curExtraSku.extraSkuPrice *
                                              _vm.productBuyNum
                                            : 0)
                                      ).toFixed(2)
                                    )
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "btnBox" }, [
                  _vm.currentProductData.activityType === 0 &&
                  (_vm.currentProductData.stockNumber !== 0 ||
                    _vm.productDetailData.ifOversold == 1) &&
                  _vm.productDetailData.shelveState
                    ? _c(
                        "div",
                        { staticClass: "buyBox" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "150px",
                                height: "60px",
                                "font-size": "18px"
                              },
                              attrs: {
                                disabled: _vm.ableToBuy,
                                type: "primary"
                              },
                              on: { click: _vm.buyGood }
                            },
                            [_vm._v("立即购买")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "150px",
                                height: "60px",
                                "font-size": "18px"
                              },
                              attrs: { disabled: _vm.ableToBuy },
                              on: { click: _vm.clickAddCart }
                            },
                            [_vm._v("加入采购单")]
                          ),
                          _vm._v(" "),
                          _c(
                            "i",
                            { staticClass: "showTalkWay" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    width: "150px",
                                    height: "60px",
                                    "font-size": "18px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  我要咨询\n                  "
                                  ),
                                  _c("div", { staticClass: "talkWayDialog" }, [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            margin: "0 33px",
                                            padding: "10px 0",
                                            "border-bottom": "2px dotted #ccc"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/talk_phone.png"),
                                              alt: "",
                                              srcset: "",
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-weight": "400",
                                                color: "#333333",
                                                "margin-left": "6px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "联系电话:\n                          " +
                                                  _vm._s(
                                                    _vm.productDetailData
                                                      .servicePhone
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            margin: "0 33px",
                                            padding: "10px 0"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/talk_wx.png"),
                                              alt: "",
                                              srcset: "",
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-weight": "400",
                                                color: "#333333",
                                                "margin-left": "6px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "微信号:\n                          " +
                                                  _vm._s(
                                                    _vm.productDetailData
                                                      .serviceWechat
                                                  )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.currentProductData.activityType === 2 &&
                    (_vm.currentProductData.stockNumber !== 0 ||
                      _vm.productDetailData.ifOversold == 1) &&
                    _vm.productDetailData.shelveState) ||
                  (_vm.currentProductData.activityType === 3 &&
                    (_vm.currentProductData.stockNumber !== 0 ||
                      _vm.productDetailData.ifOversold == 1) &&
                    _vm.productDetailData.shelveState)
                    ? _c(
                        "div",
                        { staticClass: "buyBox" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "150px",
                                height: "60px",
                                "font-size": "18px"
                              },
                              attrs: {
                                disabled: _vm.ableToBuy,
                                type: "primary"
                              },
                              on: { click: _vm.buyGood }
                            },
                            [_vm._v("立即购买")]
                          ),
                          _vm._v(" "),
                          _vm.ifEnable === 1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    width: "150px",
                                    height: "60px",
                                    "font-size": "18px"
                                  },
                                  attrs: { disabled: _vm.ableToBuy },
                                  on: { click: _vm.clickAddCart }
                                },
                                [_vm._v("加入采购单")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "i",
                            { staticClass: "showTalkWay" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    width: "150px",
                                    height: "60px",
                                    "font-size": "18px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  我要咨询\n                  "
                                  ),
                                  _c("div", { staticClass: "talkWayDialog" }, [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            margin: "0 33px",
                                            padding: "10px 0",
                                            "border-bottom": "2px dotted #ccc"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/talk_phone.png"),
                                              alt: "",
                                              srcset: "",
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-weight": "400",
                                                color: "#333333",
                                                "margin-left": "6px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "联系电话:\n                          13409872345"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            margin: "0 33px",
                                            padding: "10px 0"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/talk_wx.png"),
                                              alt: "",
                                              srcset: "",
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-weight": "400",
                                                color: "#333333",
                                                "margin-left": "6px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "微信号: 13409872345\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.activityType === 1 &&
                  (_vm.currentProductData.stockNumber !== 0 ||
                    _vm.productDetailData.ifOversold == 1) &&
                  _vm.productDetailData.shelveState
                    ? _c(
                        "div",
                        { staticClass: "favorites" },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "150px",
                                height: "60px",
                                "font-size": "18px"
                              },
                              attrs: {
                                disabled: _vm.ableToBuy,
                                type: "primary"
                              },
                              on: { click: _vm.buyGood }
                            },
                            [_vm._v("立即购买")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "150px",
                                height: "60px",
                                "font-size": "18px"
                              },
                              attrs: { disabled: _vm.ableToBuy },
                              on: { click: _vm.clickAddCart }
                            },
                            [_vm._v("加入采购单")]
                          ),
                          _vm._v(" "),
                          _c(
                            "i",
                            { staticClass: "showTalkWay" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    width: "150px",
                                    height: "60px",
                                    "font-size": "18px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  我要咨询\n                  "
                                  ),
                                  _c("div", { staticClass: "talkWayDialog" }, [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            margin: "0 33px",
                                            padding: "10px 0",
                                            "border-bottom": "2px dotted #ccc"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/talk_phone.png"),
                                              alt: "",
                                              srcset: "",
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-weight": "400",
                                                color: "#333333",
                                                "margin-left": "6px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "联系电话:\n                          13409872345"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            margin: "0 33px",
                                            padding: "10px 0"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/talk_wx.png"),
                                              alt: "",
                                              srcset: "",
                                              width: "16px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "14px",
                                                "font-weight": "400",
                                                color: "#333333",
                                                "margin-left": "6px"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "微信号: 13409872345\n                        "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentProductData.stockNumber === 0 &&
                  _vm.productDetailData.shelveState &&
                  _vm.productDetailData.ifOversold == 0
                    ? _c("div", { staticClass: "noStock" }, [
                        _c("span", [_vm._v("已售空")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.productDetailData.shelveState
                    ? _c("div", { staticClass: "noStock" }, [
                        _c("span", [_vm._v("已下架")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "hasLeftLine",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        height: "40px",
                        cursor: "pointer",
                        "padding-left": "40px",
                        position: "relative"
                      },
                      on: {
                        click: function($event) {
                          return _vm.lookShopCat()
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            position: "relative",
                            display: "block",
                            width: "36px"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "icon-The-shopping-cart",
                            staticStyle: { "font-size": "24px" }
                          }),
                          _vm._v(" "),
                          _vm.getCurTotalNum() > 0
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    "background-color": "rgb(255, 71, 71)",
                                    color: "rgb(255, 255, 255)",
                                    "font-size": "12px",
                                    "border-radius": "50%",
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "center",
                                    width: "22px",
                                    height: "22px",
                                    position: "absolute",
                                    right: "0px",
                                    top: "-12px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.getCurTotalNum())
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "margin-left": "0px" } }, [
                        _vm._v("采购单")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.ableToBuy
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#f56c6c",
                          "font-size": "16px",
                          "margin-top": "20px"
                        }
                      },
                      [
                        _vm._v(
                          "\n            （" +
                            _vm._s(_vm.enableToBuyText) +
                            "）\n          "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                false
                  ? _c(
                      "div",
                      { staticClass: "initBuyNumBox initBuyNumBox_bottom" },
                      [
                        _c("span", [_vm._v("付款方式")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm.enablePaymentMode.indexOf(1) != -1 || _vm.shopType
                            ? _c("p", [
                                _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/images/online_pay.png"),
                                      alt: "",
                                      srcset: ""
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("在线支付")])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.enablePaymentMode.indexOf(3) != -1 || _vm.shopType
                            ? _c("p", [
                                _c("span", [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/images/offline_pay.png"),
                                      alt: "",
                                      srcset: ""
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("转账汇款")])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/online_credit_pay.png"),
                                  alt: "",
                                  srcset: ""
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("账期付款")])
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _vm.currentProductData.activityType === 1 &&
            _vm.productDetailData.collageOrders.length &&
            _vm.ifEnable === 0
              ? _c("div", { staticClass: "pinList" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pinListBox" },
                    _vm._l(_vm.productDetailData.collageOrders, function(item) {
                      return _c(
                        "div",
                        { key: item.collageId, staticClass: "pinItem" },
                        [
                          _c("div", { staticClass: "Avatar" }, [
                            _c("img", {
                              attrs: { src: item.headImage, alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pinUserInfo" }, [
                            _c("span", { staticClass: "pUserName" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "notBad" }, [
                              _vm._v(
                                "\n                还差\n                "
                              ),
                              _c("b", [_vm._v(_vm._s(item.person))]),
                              _vm._v("人拼成\n              ")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "remainingTime" }, [
                              _vm._v(
                                "\n                剩余：\n                "
                              ),
                              _c("b", [
                                _vm._v(_vm._s(_vm._f("formatTime")(item.time)))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          !item.lock
                            ? _c(
                                "div",
                                {
                                  staticClass: "pinBtn",
                                  on: {
                                    click: function($event) {
                                      return _vm.goToGroupBuy(item.collageId)
                                    }
                                  }
                                },
                                [_vm._v("\n              和Ta拼\n            ")]
                              )
                            : _c("div", { staticClass: "pinBtn" }, [
                                _vm._v("已结束")
                              ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.tuijianItem.length > 0
          ? _c("div", { staticClass: "tuijianModel" }, [
              _c("div", { staticClass: "tuijian" }, [
                _c(
                  "div",
                  { staticClass: "beijing" },
                  [
                    _vm.noProduct
                      ? _c(
                          "swiper",
                          {
                            staticClass: "swiper lunbo",
                            attrs: { options: _vm.swiperOption }
                          },
                          [
                            _vm._l(_vm.tuijianItem, function(item) {
                              return _c(
                                "swiper-slide",
                                { key: item, staticClass: "swiper-slide cel" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "swiper-content",
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-top": "6px"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "142px",
                                          height: "142px"
                                        },
                                        attrs: {
                                          src: item.image,
                                          alt: "",
                                          srcset: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toProductDetail(item)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "swiper-pagination",
                              attrs: { slot: "pagination" },
                              slot: "pagination"
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "swiper-button-prev",
                                attrs: { slot: "button-prev" },
                                slot: "button-prev"
                              },
                              [_c("i", { staticClass: "el-icon-arrow-left" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "swiper-button-next",
                                attrs: { slot: "button-next" },
                                slot: "button-next"
                              },
                              [_c("i", { staticClass: "el-icon-arrow-right" })]
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "warp" }, [
          _c(
            "div",
            {
              staticClass: "bottom",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between"
              }
            },
            [
              _c("div", { staticClass: "shopBufen" }, [
                _c("div", { staticClass: "xinxi" }, [
                  _vm.curShop.shopLogo
                    ? _c("div", { staticClass: "topModel" }, [
                        _c("div", { staticClass: "shopMingzi" }, [
                          _c("span", { staticClass: "wenben" }, [
                            _vm._v(_vm._s(_vm.curShop.shopName))
                          ]),
                          _vm._v(" "),
                          _c("img", {
                            staticStyle: {
                              height: "20px",
                              "margin-top": "-8px",
                              "margin-left": "5px"
                            },
                            attrs: {
                              src: require("../../assets/images/wangwang.png"),
                              alt: ""
                            }
                          })
                        ])
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "topModel",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _c("div", { staticClass: "shopMingzi" }, [
                            _c("span", { staticClass: "wenben" }, [
                              _vm._v(_vm._s(_vm.curShop.shopName))
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticStyle: {
                                height: "20px",
                                "margin-top": "-8px",
                                "margin-left": "5px"
                              },
                              attrs: {
                                src: require("../../assets/images/wangwang.png"),
                                alt: ""
                              }
                            })
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _vm.adressForm.shopAdress
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "left",
                            padding: "10px 0 10px 20px"
                          }
                        },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "e",
                              staticStyle: {
                                height: "19px",
                                "line-height": "19px",
                                "margin-left": "10px"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "14px",
                                    "font-family": "MicrosoftYaHei",
                                    color: "#333333",
                                    "line-height": "19px"
                                  }
                                },
                                [_vm._v(_vm._s(this.adressForm.shopAdress))]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tiaozhuan" }, [
                    _c(
                      "div",
                      {
                        staticClass: "jindainguang",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toStore(_vm.collectData.shopId)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icon-add11" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              "font-family": "MicrosoftYaHei",
                              color: "#333333",
                              "line-height": "50px"
                            }
                          },
                          [_vm._v("进店逛逛")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "shoucang",
                        staticStyle: { cursor: "pointer" },
                        attrs: { title: "收藏" },
                        on: { click: _vm.collectShop }
                      },
                      [
                        _c("span", {
                          class:
                            "" +
                            (_vm.isCare === 0
                              ? "icon-shoucang"
                              : "icon-shoucang1")
                        }),
                        _vm._v(" "),
                        _vm.isCare === 0
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-family": "MicrosoftYaHei",
                                  color: "#333333",
                                  "line-height": "19px"
                                }
                              },
                              [_vm._v("收藏店铺")]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "14px",
                                  "font-family": "MicrosoftYaHei",
                                  color: "#333333",
                                  "line-height": "19px"
                                }
                              },
                              [_vm._v("已收藏店铺")]
                            )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "classfiy" },
                  [
                    _c("div", { staticClass: "innerclassify" }),
                    _vm._v(" "),
                    _c("el-card", { staticClass: "box-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [_c("span", [_vm._v("店内分类")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "317px", height: "540px" } },
                        [
                          _c("el-tree", {
                            attrs: {
                              data: _vm.categoryItem,
                              props: _vm.defaultProps
                            },
                            on: { "node-click": _vm.goStoreClassify }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "productDetail" },
                [
                  _c(
                    "a-tabs",
                    { attrs: { type: "card" } },
                    [
                      _c(
                        "a-tab-pane",
                        { key: "1", attrs: { tab: "商品详情" } },
                        [
                          _c("div", { staticClass: "detailBox" }, [
                            _c("div", {
                              staticClass: "detailCont",
                              domProps: {
                                innerHTML: _vm._s(_vm.productDetailData.text)
                              }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tab-pane",
                        { key: "2", attrs: { tab: "订购说明" } },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/buy_help_serv.jpg"),
                              alt: "",
                              width: "100%"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.groupBuyDialog,
            width: "30%",
            "before-close": _vm.groupBuyClose
          },
          on: {
            "update:visible": function($event) {
              _vm.groupBuyDialog = $event
            }
          }
        },
        [
          _c("span", [_vm._v("是否跟他拼团？")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.groupBuyClose } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.openGroup(0)
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "我的采购单",
            visible: _vm.showShortCar,
            width: "1200px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showShortCar = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                background: "#cccccc4f",
                padding: "10px"
              }
            },
            [
              _c(
                "span",
                {
                  style:
                    "width:" +
                    (_vm.productDetailData.timeSkuStatus ? "30" : "30") +
                    "%;padding-left:20px;"
                },
                [_vm._v("商品信息")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  style:
                    "width:" +
                    (_vm.productDetailData.timeSkuStatus ? "10" : "30") +
                    "%;text-align:center;"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.productDetailData.timeSkuStatus
                        ? "单价(元/" + _vm.productDetailData.timeSkuName + ")"
                        : "单价(元)"
                    )
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  style:
                    "width:" +
                    (_vm.productDetailData.timeSkuStatus ? "10" : "30") +
                    "%;text-align:center;"
                },
                [_vm._v("数量")]
              ),
              _vm._v(" "),
              _vm.productDetailData.timeSkuStatus
                ? _c(
                    "span",
                    { staticStyle: { width: "20%", "text-align": "center" } },
                    [
                      _vm._v(
                        "租赁时间(单位/" +
                          _vm._s(_vm.productDetailData.timeSkuName) +
                          ")"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  style:
                    "width:" +
                    (_vm.productDetailData.timeSkuStatus ? "20" : "30") +
                    "%;text-align:center;"
                },
                [_vm._v("金额(元)")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  style:
                    "width:" +
                    (_vm.productDetailData.timeSkuStatus ? "10" : "30") +
                    "%;text-align:center;"
                },
                [_vm._v("操作")]
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.shortShopCar.products, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  padding: "20px 10px",
                  border: "1px solid #E5E5E5FF",
                  "border-top": "none"
                }
              },
              [
                _c(
                  "span",
                  {
                    style:
                      "width:" +
                      (_vm.productDetailData.timeSkuStatus ? "30" : "30") +
                      "%;display:flex;align-items:stretch;"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100px",
                          height: "100px",
                          overflow: "hidden"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: item.image || _vm.productDetailData.images[0],
                            height: "100%",
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "justify-content": "space-between",
                          "box-sizing": "border-box",
                          padding: "10px 10px",
                          width: "calc(100% - 100px)"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "14px",
                              "font-weight": "bold"
                            }
                          },
                          [_vm._v(_vm._s(_vm.productDetailData.productName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "13px",
                              color: "#767676"
                            }
                          },
                          [
                            _c("div", [_vm._v(_vm._s(item.skuName))]),
                            _vm._v(" "),
                            _vm._l(item.extraSkuName, function(its, index) {
                              return _c("div", { key: index }, [
                                its
                                  ? _c("div", [_vm._v(_vm._s(its))])
                                  : _vm._e()
                              ])
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    style:
                      "width:" +
                      (_vm.productDetailData.timeSkuStatus ? "10" : "30") +
                      "%;text-align:center;"
                  },
                  [_vm._v("\n        " + _vm._s(item.price) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    style:
                      "width:" +
                      (_vm.productDetailData.timeSkuStatus ? "10" : "30") +
                      "%;text-align:center;"
                  },
                  [_vm._v("\n        x" + _vm._s(item.buyNum) + "\n      ")]
                ),
                _vm._v(" "),
                _vm.productDetailData.timeSkuStatus
                  ? _c(
                      "span",
                      { staticStyle: { width: "20%", "text-align": "center" } },
                      [
                        _c("div", [
                          _vm._v("起始日期:" + _vm._s(item.timeArea[0]))
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("结束日期:" + _vm._s(item.timeArea[1]))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    style:
                      "width:" +
                      (_vm.productDetailData.timeSkuStatus ? "20" : "30") +
                      "%;text-align:center;"
                  },
                  [_vm._v("\n        " + _vm._s(item.totalPrice) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    style:
                      "width:" +
                      (_vm.productDetailData.timeSkuStatus ? "10" : "30") +
                      "%;text-align:center;"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.delShopCarSku(item)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.shortShopCar.products.length == 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    height: "200px",
                    "margin-bottom": "-10px",
                    "font-size": "20px",
                    color: "#939393"
                  }
                },
                [_vm._v("\n      您暂未选择商品哦\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    background: "#F1F2F7FF",
                    padding: "10px 20px",
                    "margin-top": "-20px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "60%", "text-align": "left" } },
                    [
                      _c("span", [
                        _vm._v("已选规格 "),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "font-size": "18px",
                              margin: "0 4px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.shortShopCar.products.length))]
                        ),
                        _vm._v(" 种")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "margin-left": "20px" } }, [
                        _vm._v("总计数量 "),
                        _c(
                          "b",
                          {
                            staticStyle: {
                              "font-size": "18px",
                              margin: "0 4px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.getCurTotalNum()))]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-left": "auto",
                        display: "flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "baseline"
                          }
                        },
                        [
                          _c("span", [_vm._v("合计:")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#FF4747FF",
                                "margin-left": "4px"
                              }
                            },
                            [_vm._v("¥")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "20px",
                                color: "#FF4747FF",
                                margin: "0 15px 0 2px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.getCurTotalPrice()))]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            cursor: "pointer",
                            "background-color": "#F77B0BFF",
                            "font-size": "15px",
                            color: "#ffffff",
                            height: "50px",
                            margin: "-10px -20px -10px 0",
                            padding: "0 20px",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "center"
                          },
                          on: {
                            click: function($event) {
                              return _vm.groupBuyNow()
                            }
                          }
                        },
                        [_vm._v("\n            立即购买\n          ")]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("商品分类")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fightOrderTit" }, [
      _c("i", { staticClass: "iconfont" }, [_vm._v("")]),
      _vm._v(" "),
      _c("span", [_vm._v("这些人正在拼单")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d" }, [
      _c("span", { staticClass: "icon-positioning" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-319ca30f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-319ca30f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/product/productDetail_serv.vue
// module id = null
// module chunks = 